import {ContactDetails} from '../components/ContactDetails';
import {useBookingState} from '../store';
import {t} from 'i18next';
import {CeremonyLanguage} from '../components/CeremonyLanguage';
import {useNavigate} from 'react-router-dom';
import {BreakpointMinWidth, RoutePath} from '../lib/enums';
import {isContactDetailsInvalidated} from '../helpers/validations';
import AbortBooking from '../components/AbortBooking';
import {useWindowSize} from '@uidotdev/usehooks';
import {useState} from 'react';
import {UaButton, UaBreadcrumbs} from 'uppsala.ui.react';

const ContactInfoPage = () => {
  const navigate = useNavigate();
  const state = useBookingState((state) => state);
  const size = useWindowSize();
  const [highlightMissingFields, setHighlightMissingFields] = useState(false);

  return (
    <div style={{maxWidth: '500px'}}>
      <UaBreadcrumbs onClick={(linkItem) => navigate(linkItem.href)} />
      <h1>{t('booking.header.stateContactDetails')}</h1>
      <ContactDetails
        person={state.person1}
        personTitle={t('booking.form.person1')}
        personalIdentityNumberDisabled={true}
        onInputChange={(value: any, keyName: string) => state.updatePersonProperty(1, keyName, value)}
        onPersonExtendedChange={(value: any, keyName: string) => state.updatePersonExtendedProperty(1, keyName, value)}
        personNumber={1}
        highlightMissingFields={highlightMissingFields}
      />
      <ContactDetails
        style={{marginTop: '55px'}}
        person={state.person2}
        personTitle={t('booking.form.person2')}
        onInputChange={(value: any, keyName: string) => state.updatePersonProperty(2, keyName, value)}
        onPersonExtendedChange={(value: any, keyName: string) => state.updatePersonExtendedProperty(2, keyName, value)}
        personNumber={2}
        resetPersonExtended={() => state.resetPersonExtended(2)}
        highlightMissingFields={highlightMissingFields}
      />

      <div style={{marginTop: '55px'}} />
      <CeremonyLanguage onInputChange={state.setCeremonyLanguage} selectedLanguage={state.ceremonyLanguage} />

      <div style={{marginTop: '40px'}} />

      <div
        className={'flex-row'}
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '15px',
          marginTop: '55px',
          flexWrap: size.width && size.width < BreakpointMinWidth.xs ? 'wrap-reverse' : 'nowrap',
        }}>
        <AbortBooking />
        <UaButton
          title={t('button.previewBooking')}
          onClick={() =>
            !isContactDetailsInvalidated(state.person1, state.person2, state.validationFields)
              ? navigate(RoutePath.ReviewPage)
              : setHighlightMissingFields(true)
          }
          type="primary"
        />
      </div>
    </div>
  );
};

export default ContactInfoPage;
